import React from "react";

interface TableCellProps {
	value: React.ReactNode;
	colIndex: number;
	row: React.ReactNode[];
	isVirtualized?: boolean;
}

/**
 * Shared cell component for both virtualized and non-virtualized table rows
 */
export function TableCell({ value, colIndex, row, isVirtualized }: TableCellProps) {
	const stackedTrailingCells =
		row.length === 5
			? [
					{ key: "xg", value: row[2] },
					{ key: "time", value: row[3] },
					{ key: "view", value: row[4] },
				]
			: [
					{ key: "time", value: row[2] },
					{ key: "view", value: row[3] },
				];

	const cellContent = (
		<>
			{value}
			{colIndex === 0 && (
				<>
					<div className="data-table__cell-row">
						<div>{row[1] || "-"}</div>
					</div>
					<div className="data-table__cell-row">
						{stackedTrailingCells.map((stackedCell) => (
							<div key={stackedCell.key}>{stackedCell.value || "-"}</div>
						))}
					</div>
				</>
			)}
		</>
	);

	if (isVirtualized) {
		return (
			<div className={`data-table__cell ${colIndex === 0 ? "data-table__cell-first" : ""}`}>
				{cellContent}
			</div>
		);
	}

	return <td className={`data-table__cell ${colIndex === 0 ? "data-table__cell-first" : ""}`}>{cellContent}</td>;
}
